import { unstable_batchedUpdates } from 'react-dom';

// unstable_batchedUpdates (from RN) is not recognized as a function on the web, so we need to import it from react-dom
export function runStoreUpdate(fn: () => void) {
    unstable_batchedUpdates(fn);
}
